(() => {
  'use strict';
  const labels = document.currentScript.dataset;
  const set = (el, key, value) => { if (el.getAttribute(key) !== value) el.setAttribute(key, value); };
  const name = (el, value) => { if (!el.hasAttribute('aria-label') && value) set(el, 'aria-label', value); };
  const each = (root, selector, fn) => {
    if (root.matches?.(selector)) fn(root);
    root.querySelectorAll?.(selector).forEach(fn);
  };
  const swatch = el => {
    if (!el.closest('[data-swatch-option]')) return;
    set(el, 'role', 'button');
    set(el, 'tabindex', '0');
    name(el, el.dataset.value || el.textContent.trim());
    set(el, 'aria-pressed', String(el.classList.contains('is--selected')));
  };
  const review = el => {
    if (el.textContent.trim()) {
      if (el.getAttribute('aria-label') === labels.reviews) el.removeAttribute('aria-label');
    } else name(el, labels.reviews);
  };
  const imageLinkNames = {
    'tondo-hound-ultra-soft-premium-cotton-t-shirt': 'Tondo Hound T-Shirt',
    'owl-of-athena-unisex-jersey-short-sleeve-tee': 'Owl of Athena T-Shirt',
    'ancient-greek-collection': 'Ancient Greek Collection',
    'medieval-collection': 'Medieval Collection'
  };
  // Inert prevents off-screen carousel links from receiving keyboard focus.
  // Only elements made inert here are restored when the carousel reveals them.
  const slide = el => {
    // Product media and app widgets manage their own playback/focus state.
    if (!el.matches('.t4s-product, article, .t4s-instagram-item')) return;
    const restore = () => {
      if (el.hasAttribute('data-aa-inert')) { el.removeAttribute('inert'); el.removeAttribute('data-aa-inert'); }
    };
    if (!el.parentElement?.classList.contains('flickityt4s-slider')) {
      restore();
      return;
    }
    if (el.getAttribute('aria-hidden') === 'true') {
      if (!el.hasAttribute('inert')) { el.setAttribute('inert', ''); el.setAttribute('data-aa-inert', ''); }
    } else restore();
  };
  const enhance = root => {
    each(root, '[data-swatch-item]', swatch);
    each(root, '[data-menu-drawer]', el => name(el, labels.menu));
    each(root, '[data-action-wishlist]', el => name(el, labels.wishlist));
    each(root, 'a.t4s-product__review', review);
    each(root, '.t4s-banner-inner > a, .t4s-col-inner a, .t4s-eff[href*="instagram.com/p/"]', el => {
      if (el.textContent.trim()) return;
      const url = new URL(el.href, location.href);
      const title = imageLinkNames[url.pathname.split('/').filter(Boolean).pop()] || (url.hostname.endsWith('instagram.com') ? 'Instagram post' : '');
      if (!title) return;
      name(el, title);
      el.querySelectorAll('img:not([alt])').forEach(img => set(img, 'alt', title));
    });
    each(root, 'a.t4s-full-width-link, a.t4s-pr-color__value', el => {
      const title = el.closest('.t4s-product')?.querySelector('.t4s-product-title')?.textContent.trim();
      name(el, title);
    });
    each(root, '[data-decrease-qty]', el => name(el, 'Decrease quantity'));
    each(root, '[data-increase-qty]', el => name(el, 'Increase quantity'));
    each(root, '[data-quantity-value]', el => name(el, 'Quantity'));
    each(root, '.flickityt4s-slider > *, [inert]', slide);
  };
  const start = () => {
    enhance(document);
    document.addEventListener('keydown', event => {
      const el = event.target.closest('[data-swatch-item][role="button"]');
      if (!el || !['Enter', ' '].includes(event.key)) return;
      event.preventDefault();
      if (!event.repeat && !el.classList.contains('is--unavailable') && el.getAttribute('aria-disabled') !== 'true') el.click();
    });
    new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'childList') {
          for (const node of record.addedNodes) if (node.nodeType === 1) enhance(node);
          const reviewLink = record.target.closest?.('a.t4s-product__review');
          if (reviewLink) review(reviewLink);
        } else if (record.attributeName === 'aria-hidden') {
          slide(record.target);
        } else if (record.target.matches('[data-swatch-item]')) {
          swatch(record.target);
        }
      }
    }).observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'aria-hidden']});
  };
  // Phones: the theme's back-to-top button stays hidden while the page is less than one screen height from the
  // top, where it would sit over the product picture's buttons (rule: theme settings, mobile CSS); further down
  // it behaves as before.
  const nearTop = () => document.documentElement.classList.toggle('aa-btt-top', window.scrollY < window.innerHeight);
  let nearTopQueued = false;
  const queueNearTop = () => {
    if (nearTopQueued) return;
    nearTopQueued = true;
    requestAnimationFrame(() => { nearTopQueued = false; nearTop(); });
  };
  nearTop();
  window.addEventListener('scroll', queueNearTop, {passive: true});
  window.addEventListener('resize', queueNearTop, {passive: true});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
